const saveAmendment = async(payload) => {
	let {
		    amendment,
		    ...data
	    } = payload
	
	// Set config
	let config = {}
	
	if(payload.get) {
		amendment = {
			id: payload.get('amendment'),
			type: {
				key: payload.get('type')
			},
		}
		
		// Update config.
		config = {
			headers: {
				'Content-Type': 'multipart/form-data',
			},
		}
		
		// Set data.
		data = payload
	}
	
	try {
		return await axios.post(`/amendment/${amendment.id}/${amendment.type.key}/save`, data, config)
	} catch(e) {
		throw e
	}
}

const saveAttachments = async(payload) => {
	try {
		return await axios.post(`/amendment/${payload.get('amendment')}/${payload.get('type')}/attachments`, payload, {
			headers: {
				'Content-Type': 'multipart/form-data',
			},
		})
	} catch(e) {
		throw e
	}
}

const deleteAmendment = async({ amendment }) => {
	try {
		return await axios.delete(`/amendment/${amendment.id}/${amendment.type.key}/delete`)
	} catch(e) {
		throw e
	}
}

const removeAmendmentAttachment = async({
	                                        amendment,
	                                        file,
                                        }) => {
	try {
		return await axios.delete(`/amendment/${amendment.id}/${amendment.type.key}/attachment/${file.id}`)
	} catch(e) {
		throw e
	}
}

const sendAmendmentToEvaluation = async(payload) => {
	const { amendment, ...params } = payload
	
	try {
		return await axios.post(`/amendment/${amendment.id}/${amendment.type.key}/evaluation/send`, params)
	} catch(e) {
		throw e
	}
}

const updateProtocolUser = async({
	                                 amendment,
	                                 researcher,
                                 }) => {
	try {
		return await axios.post(`/amendment/${amendment.id}/${amendment.type.key}/researcher/${researcher}/update`, {
			researcher,
		})
	} catch(e) {
		throw e
	}
}

const addResearcher = async(payload) => {
	const { amendment, researcher } = payload
	
	try {
		return await axios.post(`/amendment/${amendment.id}/${amendment.type.key}/researcher/${researcher}/add`)
	} catch(e) {
		throw e
	}
}

const inviteResearchersByEmail = async({amendment, emails}) => {
	try {
		return await axios.post(
		`/amendment/${amendment.id}/${amendment.type.key}/external/researchers/invite`, { emails })
	} catch (e) {
		throw e
	}
}  

const fetchAssignedReviewers = async(payload) => {
	const { amendment, committee } = payload
	
	delete payload.committee
	delete payload.amendment
	
	try {
		return await axios.get(`/amendment/${amendment.id}/${amendment.type.key}/assigned-reviewers`, {
			params: {
				...payload,
				committee_id: committee.id
			}
		})
	} catch(e) {
		throw e
	}
}

const fetchDictums = async(payload) => {
	const { amendment, committee, ...params } = payload
	
	try {
		return await axios.get(`/amendment/${amendment.id}/${amendment.type.key}/committee/dictums`, {
			params: {
				...params,
				committee_id: committee,
			},
		})
	} catch(e) {
		throw e
	}
}

const fetchReviewersDictums = async(payload) => {
	const { amendment, committee, ...params } = payload
	
	try {
		return await axios.get(`/amendment/${amendment.id}/${amendment.type.key}/reviewer/dictums`, {
			params: {
				...params,
				committee_id: committee,
			},
		})
	} catch(e) {
		throw e
	}
}

const saveDateDictumCommittee = async(payload) => {
	const { amendment, committee, date } = payload
	
	try {
		return await axios.post(`/amendment/${amendment.id}/${amendment.type.key}/committee/date-dictum`, {
			committee_id: committee.id,
			date,
		})
	} catch(e) {
		throw e
	}
}

const fetchDateDictumCommittee = async(payload) => {
	const { amendment, ...params } = payload
	
	try {
		return await axios.get(`/amendment/${amendment.id}/${amendment.type.key}/committee/date-dictum`, {
			params: {
				...params
			},
		})
	} catch(e) {
		throw e
	}
}

const fetchReviewersCommittee = async(payload) => {
	const { amendment, ...params } = payload
	
	try {
		return await axios.get(`/amendment/${amendment.id}/${amendment.type.key}/committee/reviewers`, {
			params: {
				...params,
			},
		})
	} catch(e) {
		throw e
	}
}

const addReviewerCommittee = async(payload) => {
	const { amendment, researcher, committee } = payload
	
	try {
		return await axios.post(`/amendment/${amendment.id}/${amendment.type.key}/committee/reviewer`, {
			user_id: researcher.id,
			committee_id: committee.id,
		})
	} catch(e) {
		throw e
	}
}

const fetchReviewerInvitation = async({ amendment, user, committee }) => {
	try {
		return await axios.get(`/amendment/${amendment.id}/${amendment.type.key}/reviewer/${user.id}/invitation`, {
			params: {
				committee: committee.id,
			},
		})
	} catch(e) {
		throw e
	}
}

const replyReviewerInvite = async({ amendment, user, comments, committee, reply }) => {
	try {
		return await axios.post(`/amendment/${amendment.id}/${amendment.type.key}/reviewer/${user.id}/reply`, {
			reply,
			comments,
			committee: committee.id,
		})
	} catch(e) {
		throw e
	}
}

const fetchReviewerDictums = async({ amendment, user, committee }) => {
	try {
		return await axios.get(`/amendment/${amendment.id}/${amendment.type.key}/reviewer/${user.id}/dictums`, {
			params: {
				committee: committee.id,
			},
		})
	} catch(e) {
		throw e
	}
}

const saveReviewerDictum = async(payload) => {
	const { model, user, ...params } = payload
	
	try {
		return await axios.post(`/amendment/${model.id}/${model.type.key}/reviewer/${user.id}/dictum`, { ...params })
	} catch(e) {
		throw e
	}
}

const fetchDictumTypes = async(payload) => {
	const { amendment, ...params } = payload
	
	console.log(params)
	
	try {
		return await axios.get(`/amendment/${amendment.id}/${amendment.type.key}/committee/dictum-types`, {
			params: {
				...params
			},
		})
	} catch(e) {
		throw e
	}
}

const saveCommitteeDictum = async(payload) => {
	try {
		return await axios.post(`/amendment/${payload.get('amendment_id')}/${payload.get('amendment_type')}/committee/dictum`, payload, {
			headers: {
				'Conten-Type': 'multipart/form-data',
			},
		})
	} catch(e) {
		throw e
	}
}

const saveFinancingInformation = async(payload) => {
	const { amendment, ...params } = payload
	
	try {
		return await axios.post(`/amendment/${amendment.id}/${amendment.type.key}/financing-information`, {...params})
	} catch (e) {
		throw e
	}
}

const saveFunders = async({
	amendment,
	funders,
}) => {
	try {
		return await axios.post(`/amendment/${amendment.id}/${amendment.type.key}/funders`, {
			funders,
		})
	} catch (e) {
		throw e
	}
}

const removeFunder = async({
	amendment,
	funder,
}) => {
	try {
		return await axios.delete(`/amendment/${amendment.id}/${amendment.type.key}/funder/${funder.id}`)
	} catch (e) {
		throw e
	}
}

const fetchAmendmentFunders = async(amendment) => {
	try {
		return await axios.get(`/amendment/${amendment.id}/${amendment.type.key}/funders`)
	} catch (e) {
		throw e
	}
}

const fetchAmentmentResearchers = async(amendment) => {
	try {
		return await axios.get(`/amendment/${amendment.id}/${amendment.type.key}/researchers`)
	} catch (e) {
		throw e
	}
}

const fetchFinancingCommitments = async({ id }) => {
	try {
		return await axios.get(`/amendment/${id}/prorroga/commitments`)
	} catch (e) {
		throw e
	}
}

const addFinancingCommitment = async(payload) => {
	const { amendment, ...params } = payload
	
	try {
		return await axios.post(`/amendment/${amendment.id}/${amendment.type.key}/financing/commitment`, {
			...params,
		})
	} catch (e) {
		throw e
	}
}

const editFinancingCommitment = async({id, ...params}) => {
	try {
		return await axios.post(`/financing/extension/commitment/${id}`, {
			_method: 'PUT',
			...params,
		})
	} catch (e) {
		throw e
	}
}

const removeCommitment = async({ amendment, commitment }) => {
	try {
		return await axios.delete(`/amendment/${amendment.id}/${amendment.type.key}/financing/commitment/${commitment}`)
	} catch (e) {
		throw e
	}
}

const saveFunderAgreement = async(payload) => {
	try {
		return await axios.post(`/amendment/${payload.get('amendment_id')}/${payload.get('amendment_type')}/funder/${payload.get('funder')}/agreement`, payload, {
			headers: {
				'Content-Type': 'multipart/form-data',
			},
		})
	} catch (e) {
		throw e
	}
}

const updateFunderInformation = async(payload) => {
	try {
		return await axios.post(
			`/amendment/${payload.get('amendment_id')}/${payload.get('amendment_type')}/funder/${payload.get(
			'funder')}/update`, payload, {
			headers: {
				'Content-Type': 'multipart/form-data',
			},
		})
	} catch (e) {
		throw e
	}
}

const removeResearcher = async(payload) => {
	const { amendment, researcher } = payload
	
	try {
		return await axios.post(`/amendment/${amendment.id}/${amendment.type.key}/researcher/${researcher.id}/remove`)
	} catch (e) {
		throw e
	}
}

/**
 *
 * @param researcher
 * @returns {Promise<void>}
 */
const reinviteResearcher = async(researcher) => {
	try {
	
	}
	catch (e) {
		throw e
	}
}

/**
 *
 * @param params
 * @returns {Promise<AxiosResponse<any>>}
 */
const updateDictumFile = async(params) => {
	try {
		return await axios.post(
			`/amendment/${params.get('amendment_id')}/${params.get('amendment_type')}/dictum/file`, params, {
				headers: {
					'Content-Type': 'multipart/form-data',
				},
			})
	} catch (e) {
		throw e
	}
}

const updateEndDate = async({ amendment }) => {
	try {
		return await axios.post(
			`/amendment/${amendment.id}/${amendment.type.key}/update/date`, {
				date: amendment.end_date,
			})
	} catch (e) {
		throw e
	}
}

const sendReplyToAmendment = async(params) => {
	const {
		      amendment,
		      user,
		      reply,
	      } = params
	
	try {
		return await axios.post(`/amendment/${amendment.id}/${amendment.type.key}/${user}/reply`, {
			reply,
		})
	} catch (e) {
		throw e
	}
}

const cancelReviewerInvitation = async({
	committee,
	amendment,
	researcher,
}) => {
	try {
		return await axios.post(
			`/amendment/${amendment.id}/${amendment.type.key}/committee/${committee.id}/reviewer/${researcher}/remove`)
	} catch (e) {
		throw e
	}
}

const resendReviewerInvitation = async({
	committee,
	amendment,
	researcher,
}) => {
	try {
		return await axios.post(
			`/amendment/${amendment.id}/${amendment.type.key}/committee/${committee.id}/reviewer/${researcher}/invite`)
	} catch (e) {
		throw e
	}
}

const resendInvitation = async({
	committee,
	amendment,
	researcher,
}) => {
	try {
		return await axios.post(
			`/amendment/${amendment.id}/${amendment.type.key}/committee/${committee.id}/reviewer/${researcher}/resend`)
	} catch(e) {
		throw e
	}
}

const createReviewerDictumTask = async({ amendment, committee, user }) => {
	try {
		return await axios.post(`/amendment/${amendment.id}/${amendment.type.key}/reviewer/${user}/task/create`, {
			committee,
		})
	} catch(e) {
		throw e
	}
}

export {
	saveAmendment,
	saveAttachments,
	deleteAmendment,
	removeAmendmentAttachment,
	sendAmendmentToEvaluation,
	updateProtocolUser,
	addResearcher,
	inviteResearchersByEmail,
	fetchAssignedReviewers,
	fetchDictums,
	fetchReviewersDictums,
	saveDateDictumCommittee,
	fetchDateDictumCommittee,
	fetchReviewersCommittee,
	addReviewerCommittee,
	fetchReviewerInvitation,
	replyReviewerInvite,
	fetchReviewerDictums,
	saveReviewerDictum,
	fetchDictumTypes,
	saveCommitteeDictum,
	saveFinancingInformation,
	saveFunders,
	removeFunder,
	fetchAmendmentFunders,
	fetchFinancingCommitments,
	addFinancingCommitment,
	editFinancingCommitment,
	removeCommitment,
	saveFunderAgreement,
	updateFunderInformation,
	fetchAmentmentResearchers,
	removeResearcher,
	updateDictumFile,
	updateEndDate,
	sendReplyToAmendment,
	cancelReviewerInvitation,
	resendReviewerInvitation,
	resendInvitation,
	createReviewerDictumTask,
}
